<template>
    <div>
        <table class="table table-compact table-definition stack-xs">
            <tr>
                <td>Date</td>
                <td>{{value.createdTime | dateTime}}</td>
            </tr>
            <tr>
                <td>Amount</td>
                <td>{{value.amount | monetizeExplicit(value.currency)}}</td>
            </tr>
            <tr>
                <td>Id</td>
                <td><router-link :to="{name: 'transaction-details', params: {id: value.id}}">{{value.id}}</router-link></td>
            </tr>
            <tr>
                <td>Type</td>
                <td class="padding-bottom-xxs"><r-badge :type="getBadgeType('transactionType', value.type)">{{value.type | unKebabCase}}</r-badge></td>
            </tr>
            <tr>
                <td>Result</td>
                <td><r-badge :type="getBadgeType('transactionResult', value.result)">{{value.result | unKebabCase}}</r-badge></td>
            </tr>
        </table>
    </div>
</template>

<script>
    import {getBadgeType} from '@/data/badges-color-map';

    export default {
        name: 'search-result-title-transactions',
        props: {
            value: {
                type: Object,
                required: true,
            },
        },
        methods: {
            getBadgeType,
        },
    };
</script>
